module.exports = __webpack_public_path__ + "static/media/design.195bcf68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/design.png
// module id = 2104
// module chunks = 0